module.exports = "<div class=\"y-dropdown\" data-bind=\"\n  transferdom: isTransferDom,\n  style: style,\n  event: {\n    mouseenter: onEnter,\n    mouseleave: onLeave\n  },\n  css: {\n    animated: animated,\n    slideInUp: isShow && !dropStyle,\n    slideOutUp: !isShow(),\n    hidden:!isShow()\n  }\">\n  <!-- ko template: { nodes: $componentTemplateNodes } -->\n  <!-- /ko -->\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/dropdown/index.html
// module id = 371
// module chunks = 0